import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getForm } from 'common/entities/form/selectors';

import { FormEditorRow } from './FormEditorRow';

import { getFormId } from '../../selectors';
import { openEditFormSubmitButton } from '../../actions';

const SUBMIT_LABEL = 'Submit Button';
const SUBTITLE_FALLBACK = 'Submit';

class ButtonNode extends React.Component {
    static propTypes = {
        submitButtonLabel: PropTypes.string,
        formId: PropTypes.string.isRequired,
        openEditFormSubmitButton: PropTypes.func.isRequired,
    };

    static defaultProps = {
        submitButtonLabel: null,
    };

    handleClick = (event) => {
        event.stopPropagation();
        this.props.openEditFormSubmitButton(this.props.formId);
    };

    render() {
        return (
            <FormEditorRow subtitle={this.props.submitButtonLabel || SUBTITLE_FALLBACK} onClick={this.handleClick}>
                {SUBMIT_LABEL}
            </FormEditorRow>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const form = getForm(state, formId);

    return {
        formId: form ? form.id : null,
        submitButtonLabel: form ? form.submitButtonLabel : null,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            openEditFormSubmitButton,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(ButtonNode);
